import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/Auth.vue'),
    children: [
      {
        path: '/',
        name: 'Login',
        component: () => import('../pages/auth/login.vue'),
      },
    ]
  },
  {
    path: '/main',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/',
        name: 'RegistrationSearch',
        component: () => import('../pages/registration/registrationSearch.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
